import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { budgetApiActions } from './actions';

export interface State {
  budgets: any[];
  loading: boolean;
  error: string;
  isUpdate: boolean;
  id: number;
}

export const initialState: State = {
  budgets: [],
  loading: false,
  error: '',
  isUpdate: false,
  id: 0,
};

export const budgetFeature = createFeature({
  name: 'budget',
  reducer: createReducer(
    initialState,
    on(budgetApiActions.loadBudget, (state) => ({
      ...state,
      loading: true,
    })),
    on(budgetApiActions.loadBudgetSuccess, (state, { budgets }) => ({
      ...state,
      budgets,
      loading: false,
    })),
    on(budgetApiActions.loadBudgetFailure, (state) => ({
      ...state,
      loading: false,
      error: 'Failed to load program configs',
    })),
    on(budgetApiActions.saveBudget, (state) => ({
      ...state,
      loading: true,
    })),
    on(budgetApiActions.saveBudgetSuccess, (state, { budget, file }) => ({
      ...state,
      budgets: [...state.budgets, budget],
      loading: false,
    })),
    on(budgetApiActions.deleteBudget, (state) => ({
      ...state,
      loading: true,
    })),
    on(budgetApiActions.deleteBudgetSuccess, (state) => ({
      ...state,
      loading: false,
    })),
    on(budgetApiActions.updateBudget, (state) => ({
      ...state,
      loading: true,
    })),
    on(budgetApiActions.updateBudgetSuccess, (state) => ({
      ...state,
      id: 0,
      isUpdate: false,
      loading: false,
    })),
    on(budgetApiActions.setUpdate, (state, { isUpdate, id }) => ({
        ...state,
        isUpdate,
        id,
      }))
  ),
});
export const { selectLoading, selectBudgets, selectIsUpdate, selectId } = budgetFeature;
export const sortedBudgets = createSelector(selectBudgets, (budgets: any[]) => {
  return budgets
    .map((budget) => ({
      ...budget,
      startDate: new Date(budget.startDate),
      endDate: new Date(budget.endDate),
    }))
    .filter(
      (budget) =>
        !Number.isNaN(budget.startDate.getTime()) && !Number.isNaN(budget.endDate.getTime())
    )
    .sort((a, b) => a.startDate.getTime() - b.startDate.getTime());
});
export const selectBudgetToEdit = createSelector(
  selectBudgets,
  selectId,
  (budgets, id) => {
    return budgets.find((budget) => budget.id === id);
  }
);